<template>
  <!-- Alert for almost 18 years, now 17 -->
  <div
    :class="['msg', 'icon', 'warning']"
    v-if='calcAge(17, 6) && !calcAge(18)'
  >
    <div class="icon">
        <awesomeIcon icon="info-circle"/>
    </div>
    <b>Uw kind is bijna 18 jaar oud</b><br />
    Als uw kind 18 wordt, moet de rekening worden omgezet naar een rekening op naam van uw
    kind. Stuur ons het e-mailadres van uw kind, dan zetten wij vast een rekeningaanvraag
    voor hem/haar klaar. Dit kan links in het menu via 'Contact opnemen'.
  </div>

  <!-- Alert for 18 years -->
  <div
    :class="['msg', 'icon', 'valid']"
    v-else-if='calcAge(18)'
  >
    <div class="icon">
        <awesomeIcon icon="birthday-cake"/>
    </div>
    <b>Uw kind is 18 geworden, gefeliciteerd!</b><br />
    De rekening kan nu worden omgezet naar een rekening op naam van uw kind. Om de
    rekening om te zetten, hebben wij zijn/haar e-mailadres nodig. Mocht die nog niet zijn
    toegestuurd, doe dat dan snel via 'Contact opnemen' links in het menu, dan zetten wij
    een rekeningaanvraag klaar.
  </div>
</template>
<script>
export default {
  name: 'birthdayAlert',
  props: {
    currentPort: Object,
  },
  methods: {
    calcAge(ageYears, ageMonths = 0) {
      if (this.currentPort.birthday) {
        const dateArray = this.currentPort.birthday.split('T')[0].split('-');
        const ageYear = new Date(
          Number(dateArray[0]) + Number(ageYears),
          Number(dateArray[1]) - (ageMonths !== 0 ? Number(1 + ageMonths) : 1),
          Number(dateArray[2]),
        );
        return ageYear < new Date();
      }
      return false;
    },
  },
};
</script>
